import React from 'react'
import { Link } from 'react-router-dom'


export default function JimcorbettWeddEvents() {
  return (
    <>
      <section className='jimcorbettweddevents-area'>
        <div className='container'>
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <Link to="/resort-de-coracao-corbett/wedding" className="goadinning-box">
                <picture>
                  <img src="/image/jimcorbett-wedding-img.webp" className="img-responsive" alt="dinning" loading="lazy" />
                </picture>
                <div>
                  <p>Weddings</p>
                  <img src="/image/mediumright-arrow.svg" alt="arrow" loading="lazy" />
                </div>
              </Link>

            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <Link to="/resort-de-coracao-corbett/meeting" className="goadinning-box">
                <picture>
                  <img src="/image/jimcorbett-mice-event.webp" className="img-responsive" alt="dinning" loading="lazy" />
                </picture>
                <div>
                  <p>MICE & Events</p>
                  <img src="/image/mediumright-arrow.svg" alt="arrow" loading="lazy" />
                </div>
              </Link>

            </div>
          </div>
        </div>
      </section>

    </>
  )
}
